// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:1024px){.sticky-quotes-top{position:fixed;top:60px;width:550px;max-height:calc(100vh - 100px);overflow-y:scroll}.generated-quotes{width:calc(100% - 550px)}.quote-textarea{height:calc(100vh - 500px)}}", ""]);
// Exports
module.exports = exports;
